<template>
  <div class="content">
   <a-row :gutter="[16,16]">
       <a-col :span='6'>

           <div class="staticNum">
                <p class="numTitle">
                    已注册系统
                </p>
                <router-link class="numValue"  :to="{path:'/system/syslist',query: {}}">
                    {{sumData.systemcount}}
                </router-link>
           </div>
       </a-col>
       <a-col :span='6'>
           <div class="staticNum">
                <p class="numTitle">
                    已注册应用
                </p>
                <router-link class="numValue"  :to="{path:'/system/appmanage',query: {}}">
                    {{sumData.appcount}}
                </router-link>
           </div>
       </a-col>

       <a-col :span='6'>
           <div class="staticNum">
                <p class="numTitle">
                    域名申请数
                </p>
                <router-link class="numValue"  :to="{path:'/system/domainurl',query: {}}">
                    {{sumData.domaincount}}
                </router-link>
           </div>
       </a-col>
       <a-col :span='6'>
           <div class="staticNum">
                <p class="numTitle">
                    服务数
                </p>
                <router-link class="numValue"  :to="{path:'/servicekey/list',query: {}}">
                    {{sumData.servicecount}}
                </router-link>
           </div>
       </a-col>
   </a-row>

    <a-row :gutter="[16,16]">
      <a-col :span='18'>
          <warhchart />
          <!-- <servicerequest></servicerequest> -->
      </a-col>
      <a-col :span='6'>
         <a-card title="快捷入口" :bordered="false" class="linkclass" >
             <div class="link_box">
                    <router-link
                            :to="{
                            path:'/guide/process',
                            query: {
                            }
                        }"
                        >系统创建引导</router-link>
                <router-link
                            :to="{
                            path:'/servicekey/add',
                            query: {
                            }
                        }"
                        >新增服务</router-link>
                <router-link
                            :to="{
                            path:'/ums/user',
                            query: {
                            }
                        }"
                        >用户管理</router-link>
                <router-link
                            :to="{
                            path:'/rc/io/authservice',
                            query: {
                            }
                        }"
                        >流控降级</router-link>
                <router-link
                            :to="{
                            path:'/qualitymanager/qualityreport',
                            query: {
                            }
                        }"
                        >质量报告</router-link> 
                <router-link
                            :to="{
                            path:'/monitorerror/overview',
                            query: {
                            }
                        }"
                        >异常分析</router-link> 
                <router-link
                            :to="{
                            path:'/monitorweb/overview',
                            query: {
                            }
                        }"
                        >前端监控</router-link> 

                        

                        
        </div>

        
        </a-card>
      </a-col>
     
    </a-row>

     

  </div>
</template>

<script>
import warhchart from "./warnchart"
// import servicerequest from "./servicerequest"
export default {
    data(){
        return {
            sumData:{
                systemcount:0,
            }
        }
    },
    methods:{
        getSumData(){
            this.$store.dispatch({
                type: "home/querysumdata",
                params:{
                    urlparams:false
                }
            }).then((res)=>{
                if(res.status == 200){
                    this.sumData.isoverview = true;
                    this.sumData.isperhour = true;
                    this.sumData = res.data.data;
                }

            });
        },
  

    },
    components:{
        warhchart,
        // servicerequest
    },
    mounted(){
        this.getSumData();
    }
};
</script>

<style scoped>
.content{
  background-color: #f0f2f5; padding: 20px;min-width:900px;
}

.linkStyle a,.linkclass a{
    float:left;
    margin-right: 12px;
    padding: 0 12px;
    margin-bottom: 8px;
    height: 32px;
    width:auto;
    font-size: 12px;
    border-radius: 4px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    border:1px solid #1890ff;
    color: #1890ff;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
}

.linkStyle a:hover,.linkclass a:hover{
    border-color: #1b8cf5 !important;
}


.staticNum{
    width:100%;
    height:auto;
    background-color: white;
    padding: 20px;

}

.numTitle{
    margin-bottom: 4px;
    color: #4e4e4ed9;
    font-size: 14px;
}

.numValue{
    color: rgba(0, 0, 0, 0.85);
    font-size: 24px;
    text-decoration: underline;
}

.link_box{
    width:100%;
    min-height: 370px;
}
</style>